<div class="profile-container">
    <div class="">
        <div class="profile-content">
          <!-- <button class="add-ticket" data-toggle="modal" data-target="#exampleModal">Add route</button>
  
            <div class="personal-details">
                <h4 class="personal-details-title">Route Controller List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Route Name</th>
                      <th scope="col">Route Status</th>
                      <th scope="col">Action</th>
                     
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let data of RouteData | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count
                     };let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{data.routeName}}</th>
                      <th scope="col">{{data.routeStatus}}</th>
                      <th scope="col">
                        <svg xmlns="http://www.w3.org/2000/svg" (click)="getRouteById(data.routeId)" data-toggle="modal" data-target="#viewModal"   width="18" height="18" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16">
                          <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                          <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                        </svg>
                      </th>
                    </tr>
                       
                  </tbody>
              </table>
              <div class="pagination-block" *ngIf="RouteData.length != 0">
                <pagination-controls
                  previousLabel="Prev"
                  nextLabel="Next"
                  (pageChange)="onTableDataChange($event)"
                >
                </pagination-controls>
            </div>
  
        </div> -->

        <div class="personal-details">

          <div class="header-block">
              <div class="header-title">
                  <p>Route Controller List</p>
              </div>
              <div class="add-block">
                  <div class="search">
                      <form autocomplete="off" >
                          <input type="text" placeholder="search privilege">
                      </form>
                      <i class="bi bi-search" ></i>
                  </div>
                  <button *ngIf="actionControls.isAdd" data-toggle="modal" data-target="#exampleModal"><i class="bi bi-plus-lg"></i> Add</button>
              </div>
          </div>
        
          <table class="table table-striped">
              <thead>
                  <tr>
                    <th style="width: 40%;">Route Name</th>
                    <th style="width: 40%;">Route Status</th>
                    <th style="width: 20%;text-align: center;padding: 0;" class="">Action</th>
                  </tr>
              </thead>
          </table>
          <div *ngIf="!isLoading">
              <div class="data-view" *ngFor="let route of RouteData | paginate : {
                  itemsPerPage: tableSize,
                  currentPage: page,
                  totalItems: count
                  }  ;let i = index">
  
                  <p style="width: 40%;">{{route.routeName}}</p>
                  <p style="width: 40%;padding-left: 25px;">{{route.routeStatus}}</p>
                  <p class="action-buttons" style="width: 20%;padding-left: 25px;">
                      <i *ngIf="actionControls.isModify" (click)="getRouteById(route.routeId)" data-toggle="modal" data-target="#updateModal" class="bi bi-pencil-square"></i>
                      <i *ngIf="actionControls.isView" (click)="getRouteById(route.routeId)" data-toggle="modal" data-target="#viewModal" class="bi bi-eye-fill"></i>
                      <i *ngIf="actionControls.isDelete" (click)="seleteRoute(route.id)" data-toggle="modal" data-target="#deleteModal" class="bi bi-trash3"></i>
                  </p>
              </div>
          </div>
  
  
          <div class="loader" *ngIf="isLoading">
              <div class="spinner"></div>
          </div>
  
          <div class="loader"  *ngIf="!isLoading && RouteData.length == 0">
              <div class="no-data">
                  <img src="assets/no-data-6.png" alt="">
                  <p>no data found</p>
              </div>
              
          </div>
  
          <div class="paginator">
              <p-paginator (onPageChange)="onTableDataChange($event)" [first]="first" [rows]="tableSize" [totalRecords]="count"
                  [showFirstLastIcon]="false" [showCurrentPageReport]="true" currentPageReportTemplate="{first} - {last} of {totalRecords}"></p-paginator>
          </div>
  
    
      </div>
    </div>
</div>
  
  
<div class="modal fade" id="exampleModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Add Route
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div>
  
          <div [formGroup]="form">
            <div class="row">
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label>Route Name</label>
                  <input formControlName="routeName" type="text" class="form-control">
                </div>
              </div>
            </div>


            <div formArrayName="routeDetailResponses">
              <div *ngFor="let object of form.controls.routeDetailResponses['controls'];let i = index;let last = last" [formGroupName]="i">
                  <div class="row">
                      <div class="col-md-5 col-lg-5">
                          <div class="form-group">
                            <input formControlName="currentLatitude" placeholder="enter Latitude" type="text" class="form-control">
                          </div>
                      </div>
                      <div class="col-md-5 col-lg-5">
                        <div class="form-group">
                          <input formControlName="currentLongitude" placeholder="enter Longitude" type="text" class="form-control">
                        </div>
                    </div>
                      <div class="col-md-2 col-lg-2 paramBtn" *ngIf="last">
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="addrouteDetailResponses()" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                              <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                          </svg>
                          <svg xmlns="http://www.w3.org/2000/svg" *ngIf="i!=0" (click)="removerouteDetailResponses(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                              <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                          </svg>
                      </div>
                      <div class="col-md-2 col-lg-2 paramBtn1" *ngIf="!last">
                          <svg xmlns="http://www.w3.org/2000/svg" (click)="removerouteDetailResponses(i)" fill="currentColor" class="bi bi-dash-circle" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                              <path d="M4 8a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7A.5.5 0 0 1 4 8z"/>
                          </svg>
                      </div>
                  </div>
              </div>
            </div>
 
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="addRoute()" class="btn btn-primary">Add route</button>
      </div>
    </div>
  </div>
  </div>
</div>
</div>



<div class="modal fade" id="viewModal" tabindex="-1"  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Route Details
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
          <div *ngFor="let route of singleRoute">
          <div class="row" >
            <div class="col-md-12 col-lg-12">
              <div class="form-group">
                <label>Route Name</label>
                <input value="{{route.route.routeName}}" readonly type="text" class="form-control">
              </div>
            </div>
            <!-- <div class="col-md-6 col-lg-6">
              <div class="form-group">
                <label>Param Type</label>
                <input value="{{route.route.routeStatus}}" readonly type="text" class="form-control">
              </div>
            </div> -->
          </div>



          <div class="row" *ngIf="route.routeDetailResponses.length != 0">
              <div class="col-md-12 col-lg-12">
                <div class="form-group">
                  <label for="" style="display: flex;text-align: center;justify-content: center;">Route Details</label>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6 col-lg-6">
                  <label style="margin-left: 15px;">Latitude</label>
                </div>
                <div class="col-md-6 col-lg-6">
                  <label>Longitude</label>
                </div>
              </div>
              <div *ngFor="let routeDetails of route.routeDetailResponses">
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <input value="{{routeDetails.currentLatitude}}" readonly   type="text" class="form-control">
                  </div>
                </div>
                <div class="col-md-6 col-lg-6">
                  <div class="form-group">
                    <input value="{{routeDetails.currentLongitude}}" readonly   type="text" class="form-control">
                  </div>
                </div>
              </div>
          </div>
        </div>  
      <div class="modal-footer">
        <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
      </div>
    </div>
  </div>
  </div>
</div>



<div class="modal fade" id="deleteModal" tabindex="-1" data-backdrop="static" aria-labelledby="deleteModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">Confirmation!!
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <p>are you sure? want to delete??</p>   
      <div class="modal-footer">
        <button type="button" id="closeModalButton3"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="deleteRoute()" class="btn btn-primary">Delete</button>
      </div>
    </div>
  </div>
</div>
</div>


<div class="modal fade" id="updateModal" tabindex="-1"  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Modify Route Controller
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
        <div [formGroup]="form">
            <div class="row" >
                <div class="col-md-12 col-lg-12">
                  <div class="form-group">
                    <label>Route Name</label>
                    <input formControlName="routeName" type="text" class="form-control">
                  </div>
                </div>
            </div>
        </div>
      <div class="modal-footer">
        <button type="button" id="closeModalButton" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="updateRoute()" class="btn btn-primary" data-dismiss="modal">save changes</button>
      </div>
    </div>
  </div>
  </div>
</div>